import styles from './Card.module.css'

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Renders the card with an elevated shadow */
  elevated?: boolean
  /** Renders the card with a branded/highlighted border */
  highlighted?: boolean
  /** Makes the card focusable and interactive (adds button role) */
  interactive?: boolean
}

export function Card({
  elevated = false,
  highlighted = false,
  interactive = false,
  children,
  className,
  onClick,
  ...rest
}: CardProps) {
  const classes = [
    styles.root,
    elevated ? styles.elevated : '',
    highlighted ? styles.highlighted : '',
    interactive ? styles.interactive : '',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ')

  if (interactive) {
    return (
      <div
        role="button"
        tabIndex={0}
        className={classes}
        onClick={onClick}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            onClick?.(e as unknown as React.MouseEvent<HTMLDivElement>)
          }
        }}
        {...rest}
      >
        {children}
      </div>
    )
  }

  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  )
}
